import { Col, Row } from "react-bootstrap";
import { NFLookupCurrency } from "../../../../Shared/NewForms/NFlookupCurrency";
import { useTranslation } from "react-i18next";
import { NFIntInput } from "../../../../Shared/NewForms/NFIntInput";
import { useFormContext } from "react-hook-form";

const IncomingCashsCurrencyConversionDetail = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  return (
    <Row>
      <Col sm={6}>
        <NFIntInput fieldName={"amountWithVat"} title={t("InTheAmountOf")} />
      </Col>
      <Col sm={6}>
        <NFLookupCurrency title={t("ConvertedCurrency")} fieldName={"convertedCurrencyId"} required />
      </Col>
    </Row>
  );
};

export default IncomingCashsCurrencyConversionDetail;
